export default __webpack_public_path__ + "static/media/65.45e804d0.png";